import { render, staticRenderFns } from "./ResearchDynamics.vue?vue&type=template&id=7d04e269&scoped=true"
import script from "./ResearchDynamics.vue?vue&type=script&lang=js"
export * from "./ResearchDynamics.vue?vue&type=script&lang=js"
import style0 from "./ResearchDynamics.vue?vue&type=style&index=0&id=7d04e269&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d04e269",
  null
  
)

export default component.exports